export default __webpack_public_path__ + "static/media/CELLAR.148ef5ec.png";